import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import ErrorScreen from "../ErrorScreen/ErrorScreen";

interface ErrorScreenGuardProps {
    systemIsHealthy: boolean;
    hasNetworkConnection: boolean;
    children: ReactNode;
}

const ErrorScreenGuard = ({ systemIsHealthy, hasNetworkConnection, children }: ErrorScreenGuardProps) => {
    const { t } = useTranslation();

    const shouldShowMaintenance = !systemIsHealthy || !hasNetworkConnection;

    const getMaintenanceProps = () => {
        if (!hasNetworkConnection) {
            return {
                message: t("no-network-message"),
                title: t("no-network-title"),
                description: t("no-network-description"),
                showTimer: false
            };
        }

        return {
            message: t("maintenance-message"),
            title: t("maintenance-title"),
            description: `${t("maintenance-description")} ${t("please-wait-3min")}`,
            footer: t("maintenance-footer"),
            showTimer: true,
            timerSeconds: 180
        };
    };

    if (shouldShowMaintenance) {
        return <ErrorScreen {...getMaintenanceProps()} />;
    }

    return <>{children}</>;
};

export default ErrorScreenGuard;

